export default __webpack_public_path__ + "static/media/09-bodegas-compostela.c006efd5.png";